export default {
    event_category: 'content',
    site_domain_type: 'lp'
}
